export enum ESlackChannelStatus {
  ACTIVE = 'active',
  SUSPEND = 'suspend'
}
